import { createServerFn } from "@tanstack/react-start";
import { getRequest } from "@tanstack/react-start/server";
import { z } from "zod";


const contactSchema = z.object({
  nome: z.string().min(2),
  email: z.string().email(),
  telefone: z.string().optional(),
  assunto: z.string().min(2),
  mensagem: z.string().min(10),
  user_id: z.string().uuid().optional(),
});

export const submitContact = createServerFn({ method: "POST" })
  .validator((data: unknown) => contactSchema.parse(data))
  .handler(async ({ data }) => {
    const { supabaseAdmin: supabase } = await import("@/integrations/supabase/client.server");
    const request = getRequest();
    // Basic Rate Limiting check
    const ip = request?.headers.get("x-forwarded-for") || "unknown";
    const identifier = `contact_${ip}`;

    const { data: limitData } = await supabase
      .from("contato_rate_limit" as any)
      .select("*")
      .eq("identifier", identifier)
      .single() as { data: any };

    const now = new Date();
    if (limitData) {
      const lastRequest = new Date(limitData.last_request);
      const diffMinutes = (now.getTime() - lastRequest.getTime()) / (1000 * 60);

      if (diffMinutes < 5 && limitData.request_count >= 3) {
        throw new Error("Muitas mensagens enviadas. Tente novamente em alguns minutos.");
      }

      const newCount = diffMinutes > 30 ? 1 : limitData.request_count + 1;
      await supabase
        .from("contato_rate_limit" as any)
        .update({ last_request: now.toISOString(), request_count: newCount })
        .eq("identifier", identifier);
    } else {
      await supabase
        .from("contato_rate_limit" as any)
        .insert({ identifier, last_request: now.toISOString(), request_count: 1 });
    }

    const { error } = await supabase.from("contatos" as any).insert({
      ...data,
      status: "novo",
    });

    if (error) {
      console.error("Supabase error:", error);
      throw new Error("Erro ao salvar mensagem.");
    }

    return { success: true };
  });
